import { useState, useEffect } from 'react';
import axios from 'axios';
import Room from '../components/Room';
import '../styles/styles.css';
import SearchBar from '../components/home/SearchBar';
import '../styles/allapartaments.css';

export default function AllApartaments() {
    const [ data, setData ] = useState(null);

    async function getData() {
        try {
        await axios({
            method: 'get',
            // url: 'http://localhost:3002/api/all-rooms'
            url: 'https://sunnydays-backend-c82612a62427.herokuapp.com/api/all-rooms'
        }).then(response => setData(response.data))
        } catch(error) {
        console.log(error)
        }
    }

    useEffect( () => {
        getData();
    }, []);

    const LoadingTabs = () => (
        <>
        <div className='skeleton-tab'/>
        <div className='skeleton-tab'/>
        <div className='skeleton-tab'/>
        <div className='skeleton-tab'/>
        </>
    )

    const Rooms = ({data}) => { return data && data.map((item, index) => <Room key={index} data={item}/>) }

    return (
        <div className='dev-home'>
        <SearchBar/>
        <div className='dev-apartaments-list'>
            <div className='list all all-apartaments'>
            {!data ? <LoadingTabs/> : <Rooms data={data}/>}
            </div>
        </div>
        </div>
    );
}